import Button from "../../base/Button";

const renderIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="26"
        viewBox="0 0 25 26"
    >
        <g fill="none" fillRule="evenodd" stroke="#FFF">
            <path d="M19.784 13H.75" />
            <path
                strokeLinecap="square"
                d="M8.198 5.552L.75 13l7.448 7.448M23.922 1.414v23.172"
            />
        </g>
    </svg>
);

/**
 * Toolbar button for moving selected lights to the left.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered move left button.
 */
const MoveLeftButton = (props) => <Button {...props} renderIcon={renderIcon} />;

export default MoveLeftButton;
